import React, { Component } from 'react';
import { connect } from 'react-redux';

import Info from './Info';
import Timeline from './Timeline';
import TrackingManager from './TrackingManager';

import './styles.css';

class TrackingDetailsTracking extends Component {

  render() {
    const {
      data,
      customerUsersList,
      customerUsersTotal,
      customerUsersCurrentPage,
      customerUsersPageLimit,
      dispatch,
      isFetching,
      onTrackingManager,
      showTrackingManager,
      showTable,
      showNewForm,
      setShowTable,
      setShowNewForm
    } = this.props;

    return (
      <React.Fragment>
        <div className="TrackingDetailsTracking">
          <Info data={data} className="TrackingDetailsTracking__info" onTrackingManager={onTrackingManager} />
          <Timeline data={data} className="TrackingDetailsTracking__timeline" />
        </div>

        <TrackingManager
          dispatch={dispatch}
          currentCustomerData={data}
          customerUsersList={customerUsersList}
          customerUsersTotal={customerUsersTotal}
          customerUsersPageLimit={customerUsersPageLimit}
          showTrackingManager={showTrackingManager}
          isFetching={isFetching}
          onClose={onTrackingManager}
          currentPage={customerUsersCurrentPage}
          showTable={showTable}
          showNewForm={showNewForm}
          setShowTable={setShowTable}
          setShowNewForm={setShowNewForm}
        />

      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    customerUsersList: state.trackingManager.customerUsersList.data || [],
    customerUsersTotal: state.trackingManager.customerUsersList.totalItems || 0,
    customerUsersCurrentPage: state.trackingManager.customerUsersList.currentPage || 1,
    customerUsersPageLimit: state.trackingManager.customerUsersList.pageLimit || 10,
    isFetching: state.trackingManager.customerUsersList.isFetching,
  };
}

export default connect(mapStateToProps)(TrackingDetailsTracking);
